// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

// Sessions, page views and replay. The event catalogue is server-side —
// see analytics.js for why the two halves do not overlap.
import "./analytics"

// SAY SOMETHING IMMEDIATELY WHEN A LINK IS PRESSED.
//
// Turbo waits 500ms before showing its progress bar, on the reasoning that
// a fast navigation should not flash one. On a phone over mobile data that
// is 500ms of a tap doing nothing visible — so people tap again, and again,
// and the queued visits arrive one after another and the app appears to
// freeze. Cody, 12 Sep: "clicking multiple links creates a backlog of
// requests and just freezes" and "loading indicator(s) - in general?"
//
// 120ms is long enough that a cached same-page frame swap does not flash
// and short enough that a real navigation is acknowledged before anybody
// reaches for a second tap.
Turbo.setProgressBarDelay(120)

// AND A MARK IN THE MIDDLE OF THE SCREEN, because a 3px line at the very
// top of a phone is easy to miss entirely — which is what had people
// tapping a second time. See shared/_loading_overlay.
//
// A class on <html>, so the CSS owns when it appears and what it looks
// like; this only says whether a visit is in flight. The 250ms delay
// before it fades in lives in the transition, so a fast navigation never
// reaches the visible state and there is no timer to cancel.
//
// turbo:visit rather than turbo:before-visit: the former fires for restore
// visits too, which is where a slow page is most frustrating.
const visiting = (on) =>
  document.documentElement.classList.toggle("is-visiting", on)

document.addEventListener("turbo:visit", () => visiting(true))
document.addEventListener("turbo:load", () => visiting(false))
// A failed or aborted visit ends without a load, and an overlay that
// outlives its navigation is worse than none.
document.addEventListener("turbo:fetch-request-error", () => visiting(false))
document.addEventListener("turbo:before-cache", () => visiting(false))

import "trix"
import "@rails/actiontext"

// Direct upload: the file goes straight to storage from the browser, and the
// form posts only a signed id. A phone photo is several megabytes, and
// sending it through a Rails request holds a worker for the whole transfer.
//
// start() binds the listeners; the file field opts in with direct_upload:
// true. See upload_controller for the progress UI.
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
